export const TIPO_TARJETA = 'sorby_tarjeta';

const FRASE_HECHO = {
  movimiento_cargado: 'registraste tus gastos',
};

const unir = (frases) => (frases.length > 1 ? `${frases.slice(0, -1).join(', ')} y ${frases[frases.length - 1]}` : frases[0]);

// El saludo cuenta lo que la persona ya hizo; los pasos que no conocemos (editables a futuro) no se nombran.
export const saludoSorbyIa = ({ nombre, onboarding } = {}) => {
  const primerNombre = String(nombre || '').trim().split(/\s+/)[0];
  const hechos = (onboarding?.pasos || []).filter((p) => p.completo && FRASE_HECHO[p.clave]).map((p) => FRASE_HECHO[p.clave]);
  const hola = primerNombre ? `Hola ${primerNombre}.` : 'Hola.';
  return hechos.length ? `${hola} Ya ${unir(hechos)}.` : hola;
};

// `modulos_actualizados` es un aviso al menú, no un botón.
export const separarAcciones = (acciones) => {
  const lista = Array.isArray(acciones) ? acciones.filter(Boolean) : [];
  return {
    tarjetas: lista.filter((a) => a.type === TIPO_TARJETA && a.payload?.titulo),
    botones: lista.filter((a) => a.type !== TIPO_TARJETA && a.type !== 'modulos_actualizados'),
  };
};

export const mensajeDeTarjeta = (accion) => accion?.payload?.mensaje || `Contame cómo funciona ${accion?.payload?.titulo || ''}`.trim();
